import banner from "../../../courses/module-2/img5.png";

const modulo5_pt = {
  courseId: "cripto-blockchain",
  id: "modulo-5",
  title: "🧩 MÓDULO 5: Segurança em Web3 – Proteja seus criptoativos",
  estimatedDuration: "1 hora e 30 minutos",
  format: "Leitura + atividade de verificação",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objetivos",
      title: "🎯 Objetivo do módulo",
      content: [
        "Entender como funcionam as wallets, o que é uma seed phrase e como evitar os principais riscos do ecossistema cripto.",
      ],
    },
    {
      id: "wallet",
      navLabel: "O que é uma wallet?",
      title: "🔐 O que é uma wallet?",
      content: [
        {
          type: "paragraph",
          text: "Uma wallet (carteira digital) é uma ferramenta que permite armazenar, enviar e receber criptomoedas.",
        },
        {
          type: "paragraph",
          text: "Tipos de wallets:",
        },
        {
          type: "table",
          headers: ["Tipo", "Descrição", "Exemplo"],
          rows: [
            [
              "Custodial",
              "Uma empresa guarda suas chaves privadas por você. Você acessa com usuário e senha.",
              "Binance, Bitso, etc.",
            ],
            [
              "Non-custodial",
              "Só você tem o controle total das suas chaves e fundos.",
              "MetaMask, Trust Wallet, Vesseo, etc.",
            ],
          ],
        },
        {
          type: "paragraph",
          text: "⚠️ Importante: Se você perder o acesso a uma wallet non-custodial e não tiver backup da seed phrase, não existe forma de recuperar seus fundos.",
        },
      ],
    },
    {
      id: "banco-vs-wallet",
      navLabel: "Wallet vs Banco",
      title: "🏦 Wallet vs Banco: Qual é a diferença?",
      content: [
        {
          type: "paragraph",
          text: "Embora ambos permitam guardar e mover dinheiro, uma wallet cripto e um banco tradicional funcionam de formas muito diferentes:",
        },
        {
          type: "table",
          headers: ["Aspecto", "Banco tradicional", "Wallet cripto"],
          rows: [
            [
              "Controle do dinheiro",
              "O banco tem custódia e pode bloquear sua conta.",
              "Você controla 100% dos fundos.",
            ],
            [
              "Requisitos para abrir conta",
              "Documentos, análise, histórico.",
              "Qualquer pessoa pode criar uma wallet.",
            ],
            [
              "Horário de funcionamento",
              "Horários limitados, dias úteis.",
              "24/7, sem interrupções.",
            ],
            [
              "Comissões",
              "Tarifas de manutenção e transferências..",
              "Taxas dependem da rede (geralmente baixas).",
            ],
            [
              "Privacidade",
              "Seus dados ficam registrados e podem ser compartilhados.",
              "Não é necessário fornecer dados pessoais.",
            ],
            [
              "Suporte",
              "Atendimento ao cliente.",
              "Em non-custodial, você é o seu próprio suporte.",
            ],
          ],
        },
        {
          type: "paragraph",
          text: "🎯 Conclusão",
        },
        {
          type: "list",
          items: [
            "Um banco oferece conveniência, mas controla seu dinheiro.",
            "Uma wallet cripto oferece liberdade total, mas exige responsabilidade total.",
          ],
        },
      ],
    },
    {
      id: "seed-phrase",
      navLabel: "Seed phrase",
      title: "🧠 Seed phrase: sua chave mestra",
      content: [
        {
          type: "paragraph",
          text: "A seed phrase é uma sequência de 12 ou 24 palavras que representa sua wallet.",
        },
        {
          type: "paragraph",
          text: "Ela é a coisa mais valiosa na Web3.",
        },
        {
          type: "paragraph",
          text: "Regras de ouro:",
        },
        {
          type: "list",
          items: [
            "Anote em papel — nunca em prints ou arquivos digitais.",
            "Guarde em um lugar seguro, físico.",
            "Nunca compartilhe com ninguém.",
          ],
        },
      ],
    },
    {
      id: "custodial-vs-non-custodial",
      navLabel: "Custodial vs Non-Custodial",
      title: "🛡️ Custodial vs Non-Custodial",
      content: [
        {
          type: "table",
          headers: ["Característica", "Custodial", "Non-Custodial"],
          rows: [
            ["Controle dos fundos", "Empresa", "Usuário"],
            [
              "Recuperação de acesso",
              "Possível (empresa ajuda)",
              "Só com a seed phrase",
            ],
            [
              "Segurança",
              "Alta se a empresa for confiável",
              "Alta se você tomar boas práticas",
            ],
            ["Exemplos", "Binance, Coinbase", "MetaMask, Trust Wallet, Vesseo"],
          ],
        },
      ],
    },
    {
      id: "riesgos",
      navLabel: "Riscos comuns",
      title: "⚠️ Riscos comuns na Web3 (e como evitá-los!)",
      content: [
        {
          type: "paragraph",
          text: "🧪 1. Phishing – Golpes que tentam roubar suas chaves",
        },
        {
          type: "list",
          items: [
            "Golpistas criam sites falsos que imitam MetaMask, Trust Wallet etc.",
            "Se você inserir sua seed phrase lá, perde tudo.",
          ],
        },
        {
          type: "paragraph",
          text: "✅ Regra máxima: nunca digite sua seed phrase em nenhum site.",
        },
        {
          type: "paragraph",
          text: "Ela só deve ser usada dentro do aplicativo oficial da wallet.",
        },
        {
          type: "paragraph",
          text: "🕷️ 2. Malware – Programas que roubam suas informações",
        },
        {
          type: "paragraph",
          text: "Tipos mais comuns:",
        },
        {
          type: "list",
          items: [
            "Clipper malware: troca o endereço que você copiou pelo endereço do golpista.",
            "Keylogger: registra tudo que você digita.",
            "Extensões falsas: parecem úteis, mas espionam seu navegador.",
          ],
        },
        {
          type: "paragraph",
          text: "Caso real: um app falso no Android alterava endereços de wallet copiados.",
        },
        {
          type: "paragraph",
          text: "✅ Evite instalar extensões e apps desconhecidos e use antivírus.",
        },
        {
          type: "paragraph",
          text: "💨 3. Rugpulls – Projetos falsos que somem com seu dinheiro",
        },
        {
          type: "list",
          items: ["Exemplo famoso: token SQUID, inspirado em “Round 6”."],
        },
        {
          type: "paragraph",
          text: "Chegou a quase US$ 2.800 e depois colapsou. Os criadores fugiram.",
        },
        {
          type: "paragraph",
          text: "✅ Evite: pesquise antes de investir. Se parece bom demais pra ser verdade, provavelmente é.",
        },
        {
          type: "paragraph",
          text: "🧪 4. Links falsos nas redes sociais",
        },
        {
          type: "list",
          items: [
            "Aparecem no Instagram, Telegram, Discord etc.",
            "Falsos “suportes técnicos” pedem sua seed phrase.",
          ],
        },
        {
          type: "paragraph",
          text: "✅ Nunca clique em links enviados por desconhecidos.",
        },
      ],
    },
    {
      id: "practicas",
      navLabel: "Boas práticas",
      title: "🔒 Boas práticas de segurança",
      content: [
        {
          type: "orderedList",
          items: [
            "Ative 2FA sempre que possível.",
            "Nunca compartilhe sua seed phrase.",
            "Baixe wallets apenas de fontes oficiais.",
            "Não salve chaves na nuvem.",
            "Verifique o endereço antes de cada transação.",
          ],
        },
      ],
    },
    {
      id: "actividad",
      navLabel: "Atividade",
      title: "📝 Atividade do módulo",
      content: [
        {
          type: "paragraph",
          text: "Parte 1: Lista de boas práticas",
        },
        {
          type: "list",
          items: [
            "Abra um novo documento no Google Docs.",
            "Escreva uma lista com suas 5 regras pessoais de segurança no mundo cripto.",
            "Exemplo de título: “Meu Manual de Sobrevivência Web3”",
          ],
        },
        {
          type: "paragraph",
          text: "Parte 2: Simulação",
        },
        {
          type: "paragraph",
          text: "Responda brevemente no mesmo documento:",
        },
        {
          type: "list",
          items: [
            "O que você faria se perdesse seu celular com sua wallet non-custodial instalada (como Vesseo ou Trust Wallet)?",
            "Quais passos seguiria para proteger ou tentar recuperar seus fundos?",
          ],
        },
      ],
    },
    {
      id: "recursos",
      navLabel: "Recursos recomendados",
      title: "📌 Recursos recomendados",
      content: [
        {
          type: "link",
          href: "https://www.binance.com/pt-BR/academy/articles/how-to-secure-your-cryptocurrency",
          text: "Binance Academy – Segurança cripto",
        },
        {
          type: "link",
          href: "https://www.bloomberglinea.com.br/2022/09/19/como-proteger-sua-carteira-de-criptomoedas/",
          text: "Bloomberglinea – Como manter suas criptos seguras",
        },
      ],
    },
    {
      id: "frase",
      navLabel: "Frase do dia",
      title: "🧠 Frase do dia",
      content: [
        "“Na Web3, não existem bancos. Não existem chefes. Só existe você. E isso significa liberdade… mas também responsabilidade!”",
      ],
    },
  ],
};

export default modulo5_pt;
